import {
  ResetPasswordPayload,
  ResetPasswordResponse,
} from "../Interfaces/ResetPasswordInterface";
import { apiClient } from "./auth";

export const resetPasswordApi = async (
  payload: ResetPasswordPayload
): Promise<ResetPasswordResponse> => {
  const response = await apiClient.post<
    ResetPasswordPayload,
    ResetPasswordResponse
  >("/auth/password/reset", payload);
  return response.data;
};

